import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const BudgetPacingCard = ({ budgetPacing }) => {
  const theme = useTheme();

  let pacingColor;
  if (budgetPacing > 0) {
    pacingColor = theme.palette.overage.main; // Red for over pace
  } else if (budgetPacing < 0) {
    pacingColor = theme.palette.secondary.main; // Green for under pace
  } else {
    pacingColor = theme.palette.text.primary; // Black for on track
  }

  const tooltipText = "Compares your actual spending to your ideal spending pace for the month. A positive percentage means you are over budget.";

  return (
    <Paper elevation={3} sx={{ p: 2, height: '100%' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="subtitle1" color="text.secondary">
          Budget Pacing
        </Typography>
        <Tooltip title={tooltipText}>
          <InfoOutlinedIcon sx={{ fontSize: '1rem', color: 'text.secondary' }} />
        </Tooltip>
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', my: 1 }}>
        <Typography variant="h4" style={{ color: pacingColor }}>
          {`${budgetPacing.toFixed(0)}%`}
        </Typography>
      </Box>
    </Paper>
  );
};

export default BudgetPacingCard;